import { Card, Classes, InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import _ from "lodash";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { PlayCount } from "../../../components/playCount/play-count";
import { SeriesSortValues, useGetSeries } from "../../../hooks";
import { setPlayFilter } from "../../../redux/slices";
import { Series as SeriesApi } from "../../../redux/slices/series-api";
import { getStringRandomLength } from "../../../utils";
import { SeriesItem } from "./series-item";
import styles from "./series.tab.module.scss";

export const Series = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState<{ sortValue: SeriesSortValues; sortDirection: string }>({
    sortValue: SeriesSortValues.name,
    sortDirection: "asc",
  });
  const dispatch = useDispatch();

  const { series, loading } = useGetSeries({ searchTerm, sort });

  if (loading) return <LoadingSeries />;

  const handleSort = (sortValue: SeriesSortValues) => {
    if (sort.sortValue === sortValue) {
      setSort({ sortValue, sortDirection: sort.sortDirection === "asc" ? "desc" : "asc" });
    } else {
      setSort({ sortValue, sortDirection: "asc" });
    }
  };

  const handleNavigateToSeries = (series: SeriesApi) => {
    dispatch(
      setPlayFilter({
        selectedSeries: { id: series.series_id, label: series.name },
        selectedTag: undefined,
        selectedPlayNameFilter: undefined,
        selectedSeason: undefined,
        selectedTeam: undefined,
      })
    );
    navigate({ pathname: "/home/draw" });
  };

  return (
    <div className={styles.seriesCardContainer}>
      <Card className={styles.card}>
        <div className={styles.searchContainer}>
          <InputGroup
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            large={true}
            placeholder="Search"
            leftIcon="search"
            className={styles.search}
            rightElement={searchTerm ? <PlayCount playCount={series.length} /> : <></>}
          />
        </div>
        <div className={styles.seriesContainer}>
          <div className={styles.seriesHeader}>
            <div className={styles.seriesTitle} onClick={() => handleSort(SeriesSortValues.name)}>
              Series
            </div>
            <div className={styles.playsNumberHeader} onClick={() => handleSort(SeriesSortValues.noOfPlays)}>
              # of Plays
            </div>
          </div>

          {series.map((series) => (
            <SeriesItem series={series} key={series.id} onClick={() => handleNavigateToSeries(series)} />
          ))}
        </div>
      </Card>
    </div>
  );
};

const LoadingSeries = () => {
  // create fakeSeries array with 40 items
  const fakeSeries = _.range(40);

  return (
    <div className={styles.seriesContainer}>
      <div className={styles.seriesHeader}>
        <div className={classNames(styles.seriesTitle, Classes.SKELETON)}>Series</div>
        <div className={classNames(styles.playsNumberHeader, Classes.SKELETON)}># of Plays</div>
      </div>

      {fakeSeries.map((series, index) => (
        <LoadingSeriesItem key={index} />
      ))}
    </div>
  );
};

const LoadingSeriesItem = () => {
  return (
    <div className={styles.seriesItem}>
      <div className={styles.seriesNameContainer}>
        <div>
          <span className={Classes.SKELETON}>{getStringRandomLength(8, 20)}</span>
        </div>
      </div>
      <div className={styles.seriesInfoEditContainer}>
        <div className={styles.playsNumber}>
          <span className={Classes.SKELETON}>{getStringRandomLength(1, 3)}</span>
        </div>
      </div>
    </div>
  );
};
